import { Card, Checkbox, Divider } from "antd";
import React, { useState } from "react";

function SuperAdminModules({ selectedRole }) {
  const careAdminOption = [
    "All Tickets",
    "Clinicians",
    "Offline Registration",
    "Coupons",
    "Patient",
    "Medicines",
    "Consultations",
  ];
  const superAdminOptions = ["All Tickets", "User Management"];
  const clinicianOptions = ["My Appointments", "My Patients"];
  const [checkedList, setCheckedList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);

  const getOptionsForRole = () => {
    switch (selectedRole) {
      case "care_admin":
        return careAdminOption;
      case "super_admin":
        return superAdminOptions;
      case "doctor":
        return clinicianOptions;
      default:
        return [];
    }
  };

  const optionsToRender = getOptionsForRole();
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setCheckAll(isChecked);
    if (isChecked) {
      setCheckedList(optionsToRender);
    } else {
      setCheckedList([]);
    }
  };

  const handleCheckboxChange = (option) => {
    const newCheckedList = checkedList.includes(option)
      ? checkedList.filter((item) => item !== option)
      : [...checkedList, option];

    setCheckedList(newCheckedList);
    setCheckAll(newCheckedList.length === optionsToRender.length);
  };
  return (
    <Card>
      <div style={{ marginBottom: "15px" }}>
        Modules to be shown for {selectedRole.replace("_", " ")}
      </div>
      <div style={{ margin: "10px 0px" }}>
        <Checkbox onChange={handleSelectAll} checked={checkAll}>
          Select all
        </Checkbox>
      </div>
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}
      >
        {optionsToRender.map((option) => (
          <Checkbox
            key={option}
            value={option}
            checked={checkedList.includes(option)}
            onChange={() => handleCheckboxChange(option)}
            style={{ marginBottom: "8px" }}
          >
            {option}
          </Checkbox>
        ))}
      </div>
    </Card>
  );
}

export default SuperAdminModules;